import { Link } from "react-router-dom"
import ContainerSize from "../container"
import { FaceBookIcon, InstagramIcon, LinkedInIcon, TwitterIcon, Youtube, PhoneIcon, EmailIcon } from "../Icons"

const Footer = () => {

    const handlePhoneCall = () => {
        const phoneNumber = "7658882158";
        window.location.href = `tel:${phoneNumber}`;

    };

    const handleEmailClick = () => {
        const email = "shan@imashinsure.com";
        window.location.href = `mailto:${email}`;
    };

    return (
        <>

            <div className="bg-slate-300 pt-10 pb-10">
                <ContainerSize>
                    <div className="flex flex-col lg:flex-row gap-10 lg:gap-[160px]">

                        <div className="flex flex-col gap-5">
                            <img
                                src="/images\imashLogo.png"
                                alt="Imash Insurance Logo"
                                className="w-[150px] h-[60px]"
                            />
                            <p className="w-full lg:w-[400px] text-sm">
                                Where ideas and information Imash together to deliver distinctive solutions that fit your organization to maximize business potential.
                            </p>
                        </div>


                        <div className="flex flex-col sm:flex-row gap-10 lg:gap-[50px]">

                            <div>
                                <h3 className="pb-2 text-[#1b4a78] font-bold text-lg">
                                    CONTACT INFO
                                </h3>

                                <ul className="pl-5 flex flex-col gap-2 text-sm ">
                                    <li
                                        onClick={handlePhoneCall}

                                    >
                                        <p className="inline cursor-pointer hover:text-blue-600 hover:underline">
                                            Phone: 765-888-2158
                                        </p>

                                    </li>

                                    <li
                                        onClick={handleEmailClick}
                                        className="inline w-fit cursor-pointer hover:text-blue-600 hover:underline"
                                    >
                                        <p className="inline cursor-pointer hover:text-blue-600 hover:underline">
                                            Email: shan@imashinsure.com
                                        </p>
                                        
                                    </li>

                                    <li>
                                        <a
                                            href="https://maps.app.goo.gl/hPLVgaasvXWwNGbc9"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline cursor-pointer hover:text-blue-600 hover:underline"
                                        >
                                            <p>
                                                Headquarters: 127 W Berry St, Suite 315, Fort Wayne, IN 46802
                                            </p>
                                        </a>
                                    </li>
                                </ul>
                            </div>


                            <div>
                                <h3 className="pb-2 text-[#1b4a78] font-bold text-lg">IMPORTANT LINKS</h3>
                                <ul className="pl-5 flex flex-col gap-2 text-sm">
                                    <Link to={"/services"}><li>Services</li></Link>
                                    <Link to={"privacy-policy"}><li>Privacy Policies</li></Link>
                                    <Link to={"/contact"}><li>Quick Contact</li></Link>
                                    <Link to={"/terms-and-conditions"}><li>Terms and Conditions</li></Link>
                                    <Link to={"/faq"}><li>FAQ</li></Link>
                                </ul>
                            </div>
                        </div>
                    </div>


                    <div className="w-full h-[2px] bg-blue-300 my-6"></div>


                    <div className="flex justify-center lg:justify-end gap-4 bg-gray-700 lg:max-w-[280px] py-2 px-2 rounded-md ml-auto text-white">
                        <button
                            onClick={handlePhoneCall}
                            className="transition-transform duration-300 hover:scale-110 hover:text-blue-500"
                            aria-label="Call us"
                        >
                            <PhoneIcon />
                        </button>

                        <button
                            onClick={handleEmailClick}
                            className="transition-transform duration-300 hover:scale-110 hover:text-red-500"
                            aria-label="Email us"
                        >
                            <EmailIcon />
                        </button>

                        <a
                            href="https://www.facebook.com/profile.php?id=61574574467586"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="transition-transform duration-300 hover:scale-110 hover:text-blue-500"
                            aria-label="Facebook"
                        >
                            <FaceBookIcon />
                        </a>

                        <a
                            href="https://www.instagram.com/imash.insurance/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="transition-transform duration-300 hover:scale-110 hover:text-pink-500"
                            aria-label="Instagram"
                        >
                            <InstagramIcon />
                        </a>

                        <a
                            href="https://www.linkedin.com/company/imash-technologies/posts/?feedView=all"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="transition-transform duration-300 hover:scale-110 hover:text-blue-700"
                            aria-label="LinkedIn"
                        >
                            <LinkedInIcon />
                        </a>

                        <a
                            href="https://x.com/imashInsurance"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="transition-transform duration-300 hover:scale-110 hover:text-sky-400"
                            aria-label="Twitter"
                        >
                            <TwitterIcon />
                        </a>

                        <a
                            href="https://www.youtube.com/@Imash_insure"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="transition-transform duration-300 hover:scale-110 hover:text-red-500"
                            aria-label="YouTube"
                        >
                            <Youtube />
                        </a>

                    </div>
                </ContainerSize>
            </div>

        </>
    )
}
export default Footer